<template>
  <CContainer>
    <h3>Historial de consumos en pedidos</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow class="mt-2">
          <CCol sm="6">
            <CSelect 
              class="col-sm-12" 
              addLabelClasses="text-muted font-weight-bold" 
              label="Dependencia:"
              :value.sync="selectedDependency" 
              :options="dependencies.map(item => { 
                return { value: item.id_Dependencia, label: item.dependencia } 
              })"
              invalidFeedback="La Dependencia no ha sido asignada" />
          </CCol>
          <CCol sm="6">
            <CSelect 
              label="Categorias:"
              class="col-sm-12" 
              addLabelClasses="text-muted front-weight-bold" 
              :value.sync="selectedCiiu" 
              :options="ciius.map(item => { 
                return { value: item.id_Ciiu, label: item.descripcion } 
              })"
              invalidFeedback="La categoria no ha sido asignada" />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <div class="form-group" role="group">
              <label class="text-muted font-weight-bold col-sm-12" for="">Fecha Inicial: </label>
              <DatePicker type="date" class="col-sm-12" v-model="dateFrom" value-type="YYYY-MM-DD" format="DD/MM/YYYY"
                placeholder="dd/mm/aaaa" />
              <Datetime type="date" v-model="dateFrom" format="dd/MM/yyyy" :auto="true" class="col-sm-12 "
                input-class="col-sm-12 form-control text-right">
                <template slot="button-cancel">
                  <span></span>
                </template>
                <template slot="button-confirm">
                  <span></span>
                </template>
              </Datetime>
            </div>
          </CCol>
          <CCol sm="3">
            <div class="form-group" role="group">
              <label class="text-muted font-weight-bold col-sm-12" for="">Fecha Final:</label>
              <Datetime type="date" v-model="dateTo" format="dd/MM/yyyy" :auto="true" class="col-sm-12 "
                input-class="col-sm-12 form-control text-right">
                <!-- <template slot="date-input">
                    <b-input-group-text>
                      <CIcon name="cil-search" />
                    </b-input-group-text>
                  </template> -->
                <template slot="button-cancel">
                  <span></span>
                </template>
                <template slot="button-confirm">
                  <span></span>
                </template>
              </Datetime>
            </div>
          </CCol>
          <CCol sm="2" class="d-flex align-items-end">
            <CButton color="dark" class="mb-3" variant="outline" @click="getData()">
              <CIcon name="cil-search" />
              <span class="ml-2 align-middle">Consultar</span>
            </CButton>
          </CCol>
          <CCol sm="2" class="d-flex align-items-end">
            <CDropdown color="dark" :caret="false" class="d-inline-block mb-3">
              <template v-slot:toggler>
                <CButton color="info" variant="outline">
                  <CIcon name="cil-cloud-download" />
                  <span class="align-middle ml-2">Descargar</span>
                </CButton>
              </template>
              <CDropdownItem>
                <json-excel :fields="fileFields" :data="items" name="historialconsumospedidos.xls" class="w-100">
                  Excel
                </json-excel>
              </CDropdownItem>
              <CDropdownItem>
                <json-excel :fields="fileFields" :data="items" type="csv" name="historialcompras.csv" class="w-100">
                  CSV
                </json-excel>
              </CDropdownItem>
            </CDropdown>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mt-2">
      <CCardBody class="p-3">
        <CDataTable class="mx-3" :items="items" :fields="fields"
          :tableFilter="{ label: 'Buscar: ', placeholder: 'Digite el dato a buscar' }" :items-per-page="10" hover
          pagination>
          <template #Cantidad="{ item }">
            <td align="right">{{ item.Cantidad }}</td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
    <CElementCover v-show="loading" />
  </CContainer>
</template>

<script>
  import moment from 'moment'
  import DatePicker from "vue2-datepicker";
  import JsonExcel from 'vue-json-excel';

  import { formatter } from "@/general"
  import { dataListCiius } from "@/apiDataList";
  import { 
    dataListDependencias, 
    dataConsumosPedidosCliente 
  } from "@/api";

  const fields = [
    { key: 'Codigo', label: 'Código', _style: 'text-align:center;' },
    { key: 'Descripcion', label: 'Descripción', _style: 'text-align:center;' },
    { key: 'Referencia', label: 'Presentación', _style: 'text-align:center;' },
    { key: 'Marca', _style: 'text-align:center;' },
    { key: 'Cantidad', _style: 'text-align:center;' }
  ]

  const fileFields = {
    'Código': 'Codigo',
    'Descripción': 'Descripcion',
    'Presentación': 'Referencia',
    'Marca': 'Marca',
    'Cantidad': 'Cantidad'
  }

  export default {
    name: 'HistoricConsumptionOrders',
    components: {
      JsonExcel,
      DatePicker
    },
    data() {
      return {
        moment,
        formatter,
        loading: false,
        items: [],
        fields,
        fileFields,
        dateFrom: '',
        dateTo: '',
        dependencies: [],
        selectedDependency: '',
        ciius: [],
        selectedCiiu: ''
      }
    },
    methods: {
      async getData() {
        try {
          this.loading = true
          const { response } = await dataConsumosPedidosCliente(
            this,
            moment(this.dateFrom).utc().format('YYYY-MM-DD'),
            moment(this.dateTo).utc().format('YYYY-MM-DD'),
            this.$store.state.user.data.id_Directorio,
            this.selectedDependency.length ? this.selectedDependency : null,
            this.selectedCiiu.length ? this.selectedCiiu : null
          )
          this.items = response
          // this.items = [...response]

        } catch {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async getDependencies() {
        try {
          const data = await dataListDependencias(this, this.$store.state.user.data.id_Directorio)
          this.dependencies = [{ id_Dependencia: '', dependencia: "Seleccionar" }, ...data]
        } catch {
          console.log()
        }
      },
      async getCiius() {
        try {
          const data = await dataListCiius(this)
          this.ciius = [{ id_Ciiu: '', descripcion: 'Seleccionar' }, ...data]
        } catch {
          console.log()
        }
      }
    },
    async mounted() {
      this.dateFrom = moment().utc().subtract(1, 'years').format()
      this.dateTo = moment().utc().format()
      await this.getData()
      await this.getDependencies()
      await this.getCiius()
    },
    computed: {
      // dependency(){
      //   return this.$store.state.user.dependency
      // }
    }
  }
</script>